import styled from 'styled-components'
import { Props } from '.'
import { cores } from '../../styles'

export const Button = styled.button<Props>`
  width: ${(props) => (props.width === 'all' ? '100%' : '50%')};
  padding: 6px 12px;
  background-color: ${cores.laranja};
  border: none;
  border-radius: 4px;
  color: ${cores.branco};
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  transition: all ease 0.3s;

  &:hover {
    opacity: 0.8;
  }
`
